import { writable } from 'svelte/store';

export const donationboxes = writable([]);

export const sections = writable([
    {
        id: 123,
        width: 'large',
        sortOrder: 0,
        rows: [
            {
                cols: [
                    {
                        blocks: [
                            {
                                contentType: "text",
                                content: "text block in a row...",
                            },
                        ],
                    }
                ]
            }
        ]
    },
]);

export const page = writable({});
export const touched = writable(false);

